module.exports = __webpack_public_path__ + "img/order-icon.01c9ab3d.svg";